export enum CompanyPredefinedKey {
  CE_NBC = 'ce_nbc',
  CE_CLEARESTATE = 'ce_clearestate',
  IG_WEALTH_MANAGEMENT = 'ig_wealth_management',
  IA_FINANCIAL_GROUP = 'ia_financial_group',
  SORRELL_PRIVATE_TRUST = 'sorrell_private_trust',
  PLAN_MY_ESTATE = 'Plan my Estate',
  ECHELON = 'Echelon',
  PRAIRIE_CENTRE_CREDIT_UNION = 'Prairie Centre Credit Union',
  LAURENTIAN_BANK = 'Laurentian Bank',
  CAIN_LAMARRE = 'Cain Lamarre'
}
